import { needs, inject, ComponentEventBus, NetworkException, prop } from "fw";
import { dispatch } from "fw-state";

import { LoginForm as LoginFormModel } from "forms/login";
import { ForgotPasswordModal } from "views/login/forgot-password-modal";

import { AccountLockOutType } from "models/user";
import moment from "moment";
import { CurrentUserStore } from "state/current-user";
import { LoginFooter } from "./login-footer";

@inject
@needs(ForgotPasswordModal, LoginFooter)
export class LoginForm {
    @prop("") emailAddress!: string;
    @prop(null) token!: string;
    @prop(false) openForgotPassword: boolean;

    loginForm: LoginFormModel = null;
    loggingIn = false;
    hideValidation = false;
    showForgotPasswordModal = false;
    private lockOutData: { lockOutType: AccountLockOutType; seconds: number; message: string } = null;

    constructor(
        private ceb: ComponentEventBus,
        private currentUserStore: CurrentUserStore
    ) {}

    created() {
        this.loginForm = new LoginFormModel(this.token);
        this.loginForm.EmailAddress = this.emailAddress;

        if (this.openForgotPassword) {
            this.openForgotPasswordModal();
        }
    }

    get temporaryLockoutTime() {
        if (this.lockOutData == null) return null;
        if (this.lockOutData.lockOutType == AccountLockOutType.Temporary) {
            return moment.duration(this.lockOutData.seconds, "seconds").humanize();
        }

        return null;
    }

    get lockMessage() {
        if (this.lockOutData == null) return null;
        return this.lockOutData.message || null;
    }

    get resetRequired() {
        if (this.lockOutData == null) return false;
        return this.lockOutData.lockOutType == AccountLockOutType.ResetRequired;
    }

    get currentYear() {
        const d = new Date();
        return d.getFullYear();
    }

    get logoutReason() {
        return this.currentUserStore.state.logoutReason;
    }

    private async login() {
        this.loggingIn = true;
        this.lockOutData = null;

        try {
            await dispatch(this.loginForm);
            this.ceb.dispatch("logged-in", true);
        } catch (err) {
            if (err instanceof NetworkException) {
                if (err.result.data != null && err.result.data == "MFA") {
                    this.hideValidation = true;

                    this.ceb.dispatch("two-factor", true);

                    this.loggingIn = false;
                    return;
                }

                this.hideValidation = false;

                switch (err.result.Code) {
                    case "NOTFOUND":
                        this.loginForm.validationMessages = [`Could not log into the management portal`];
                        this.loginForm.isInvalid = true;
                        break;

                    case "BADREQUEST":
                        this.loginForm.validationMessages = [err.result.Message];
                        this.loginForm.isInvalid = true;
                        break;

                    case "FORBIDDEN":
                        if (err.result.Data && err.result.Data.lockOutType != null) {
                            this.lockOutData = err.result.Data;
                        }

                        break;
                }
            }
        }

        this.loggingIn = false;
    }

    openForgotPasswordModal() {
        this.showForgotPasswordModal = true;
    }

    closeForgotPasswordModal() {
        this.showForgotPasswordModal = false;
    }
}
